export default __webpack_public_path__ + "static/media/download.bf26b011.svg";